import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installPageLifecycleTelemetry } from './utilities/paymentFlowTelemetry';
import './index.scss';

/**
 * MSW - Start the mocking conditionally. `npm run start:mock`
 * \src\utilities\testUtilities.tsx has different status invoice types
 */
if (
  process.env.NODE_ENV === 'development' &&
  'REACT_APP_MOCK_API' in process.env
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { worker } = require('./mocks/browser');
  worker.start();
}

const {
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_ENVIRONMENT_NAME,
  REACT_APP_SENTRY_TRACE_RATE,
} = process.env;

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  integrations: [new Sentry.BrowserTracing()],
  environment: REACT_APP_SENTRY_ENVIRONMENT_NAME,
  allowUrls:
    // If running in the wild, only capture errors that orignate from our own
    // code, so we don't get noise from browser extensions or console commands.
    REACT_APP_SENTRY_ENVIRONMENT_NAME === 'local'
      ? undefined
      : [/^https?:\/\/invoice\..*\/static\/js\/.*\.js/i],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: parseFloat(REACT_APP_SENTRY_TRACE_RATE || '1'),
});

// Tag the session with how this document was reached (navigate / reload /
// back-forward, tab discarded) and record tab visibility changes as
// breadcrumbs. Used to diagnose users being bounced out of the payment step.
installPageLifecycleTelemetry();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
